import { Directive, ElementRef, HostListener, AfterViewInit } from '@angular/core';

@Directive({
  selector: '[appLatinOnly]'
})
export class LatinOnlyDirective implements AfterViewInit {
  private inputElement: HTMLInputElement;

  constructor(private el: ElementRef) {}

  ngAfterViewInit(): void {
    this.inputElement = this.el.nativeElement.tagName === 'INPUT'
      ? this.el.nativeElement
      : this.el.nativeElement.querySelector('input');
  }

  @HostListener('input', ['$event']) onInputChange(event: Event): void {
    if (!this.inputElement) return;

    const initialValue = this.inputElement.value;
    const sanitizedValue = initialValue.replace(/[^a-zA-Z0-9\s_-]/g, '');

    if (initialValue !== sanitizedValue) {
      this.inputElement.value = sanitizedValue;

      this.inputElement.dispatchEvent(new Event('input', { bubbles: true }));
      event.stopPropagation();
    }
  }
}
